import { useCallback, useEffect } from 'react';
import { useChannel } from '@/realtime/use-channel';
import { useAlertsStore, seedHistoricalAlerts, triggeredByCn } from './store';
import { env } from '@/lib/env';

let seeded = false;

/**
 * 全局挂载组件 — 订阅 risk_events 频道并写入 alerts store。
 * 放在 AppLayout 或 App 顶层渲染一次即可。
 */
export function AlertsBootstrap() {
  const pushFromRiskEvent = useAlertsStore((s) => s.pushFromRiskEvent);
  const push = useAlertsStore((s) => s.push);
  const ackByPrefix = useAlertsStore((s) => s.ackByPrefix);

  useEffect(() => {
    if (env.useMock && !seeded) {
      seeded = true;
      seedHistoricalAlerts();
    }
  }, []);

  useChannel('risk_events', pushFromRiskEvent, [pushFromRiskEvent]);

  // 紧急停机 / 强平开始 也作为告警入库(从 system 频道派生)
  const onSystem = useCallback(
    (ev: {
      type?: string;
      reason?: string;
      triggeredBy?: string;
      triggeredAt?: string;
      snapshot?: boolean;
    }) => {
      if (ev?.type === 'emergency_stop_set') {
        // 发生时间用后端 triggeredAt(真实触发时刻),不用收帧本地时间;
        // id 按 triggeredAt 派生(截到秒)→ 订阅/重连补发的快照帧会与首发去重,不重复告警。
        const occurredAt = ev.triggeredAt ?? new Date().toISOString();
        const idKey = ev.triggeredAt ? ev.triggeredAt.slice(0, 19) : 'active';
        const reasonText = ev.reason?.trim()
          ? ev.reason.trim()
          : '原因未知(请查阅告警历史 / emergency_stops_log)';
        push({
          id: `es-set-${idKey}`,
          type: 'EMERGENCY_STOP_SET',
          severity: 'CRIT',
          title: '紧急停机已激活',
          detail: `原因:${reasonText} · 触发方:${triggeredByCn(ev.triggeredBy)}`,
          occurredAt,
        });
      } else if (ev?.type === 'emergency_stop_cleared') {
        // 解除后归档活跃的「紧急停机已激活」,避免它一直挂在活跃区致活跃数失真。
        ackByPrefix('es-set-');
        push({
          id: `es-clr-${ev.triggeredAt ?? Date.now()}`,
          type: 'EMERGENCY_STOP_CLEARED',
          severity: 'INFO',
          title: '紧急停机已解除',
          occurredAt: ev.triggeredAt ?? new Date().toISOString(),
        });
      } else if (ev?.type === 'force_liquidation_started') {
        push({
          id: `fl-${Date.now()}`,
          type: 'FORCE_LIQUIDATION',
          severity: 'CRIT',
          title: '一键强制平仓已触发',
          detail: `触发方:${triggeredByCn(ev.triggeredBy)}`,
          occurredAt: new Date().toISOString(),
        });
      }
    },
    [push, ackByPrefix],
  );
  useChannel('system', onSystem, [onSystem]);

  return null;
}
